import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-movimentacao',
  templateUrl: './movimentacao.component.html'
})
export class MovimentacaoComponent {

  constructor() { }

}
